import React, { useState, useEffect } from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import { ArrowLeft, Pencil, User, Calendar, Book, Award, CheckCircle, BookOpen, Trash } from 'lucide-react';

// Importe o seu formulário de edição
// import FormAluno from './FormAluno'; 

// Importa a folha de estilos exclusiva desta view
import './alunos.css';
import AlunoAdd from './AlunosAdd';
import { deleteItem, getDocumentoUnico } from '../../../firebase/CRUD';
import { useAuth } from '../../../hooks/AuthContext';
import BackButton from '../../layout/BackButton';

export default function AlunosView() {
    const {usuario} = useAuth()
    const [AlunoInfo, setAlunoInfo] = useState({});
    const [cadastramento, setCadastramento] = useState(false);
    const [historico, setHistorico] = useState({ biblias: 0, revistas: 0, pontos: 0, presencas: 0 });
    // NOVO: filtro por trimestre na ficha do aluno.
    // null = soma os 4 trimestres (comportamento antigo, mantido como padrão).
    // 0..3 = mostra só aquele trimestre (histórico é um array de 4 posições,
    // uma por trimestre, já gravado assim desde a criação do aluno).
    const [trimestreSelecionado, setTrimestreSelecionado] = useState(null);
    
    const { id } = useParams();
    const location = useLocation();
    const navigate = useNavigate();

    // Calcula os totais de acordo com o trimestre escolhido (ou a soma dos
    // 4, se nenhum estiver selecionado). Extraído como função separada do
    // useEffect para poder ser chamado de novo só quando o trimestre mudar,
    // sem precisar buscar o documento no Firestore de novo.
    const calcularHistorico = (aluno, trimestre) => {
        if (!aluno || !aluno.historico) return { biblias: 0, revistas: 0, pontos: 0, presencas: 0 };
        const somar = (arr) => {
            if (!arr) return 0;
            if (trimestre === null) return arr.reduce((acc, val) => acc + val, 0);
            return arr[trimestre] || 0;
        };
        return {
            biblias: somar(aluno.historico.biblias),
            revistas: somar(aluno.historico.revistas),
            pontos: somar(aluno.historico.pontos),
            presencas: somar(aluno.historico.presencas),
        };
    };

    useEffect(() => {
        const salve = (aluno)=>{
            if (aluno && aluno.historico) {
                setHistorico(calcularHistorico(aluno, trimestreSelecionado));
                setAlunoInfo(aluno);
            }
        }
        getDocumentoUnico('alunos',id,salve,usuario.idEscola)
    }, [cadastramento]);

    // Recalcula os totais (sem nova consulta ao Firestore) sempre que o
    // trimestre selecionado mudar.
    useEffect(() => {
        if (AlunoInfo && AlunoInfo.historico) {
            setHistorico(calcularHistorico(AlunoInfo, trimestreSelecionado));
        }
    }, [trimestreSelecionado]);

   const ativarCadastramento = ()=>{
        setCadastramento(true)
    }
    const desativarCadastramento = ()=>{
        setCadastramento(false)
    }

    const deletarCadastro = async ()=>{
        if(window.confirm("Após apagar, os dados desse registro não serão recuperados, deseja mesmo apagar?")){
            try {
                await deleteItem('alunos',AlunoInfo.id,usuario.idEscola)
            } catch (error) {
                alert('Erro ao excluir aluno: ' + error.message)
                return
            }
            navigate(-1,{replace:true})
        }
    }
    // Funções auxiliares para a UI
    const getInicial = (nome) => nome ? nome.charAt(0).toUpperCase() : '?';
    const formatarGenero = (gen) => gen === 'F' ? 'Feminino' : gen === 'M' ? 'Masculino' : gen;

    return (
        <div className="viewContainer">
            {cadastramento && <AlunoAdd edit={AlunoInfo} cadastramento={desativarCadastramento}/>}
            {/* --- CABEÇALHO DO PERFIL --- */}
            <div className="perfil_Header">
                <div className="top-actions">
                    <button className="icon-btn" title="Voltar" onClick={() => navigate(-1)}>
                        <ArrowLeft size={22} strokeWidth={2.5} />
                    </button>
                    {usuario.perfil === "adm" && <div style={{display:'flex',gap:'10px'}}>
                       
                        <button className="icon-btn" onClick={ativarCadastramento} title="Editar Ficha">
                            <Pencil size={20} strokeWidth={2.5} />
                        </button> 
                        <button className='icon-btn'
                        onClick={deletarCadastro}
                        title='Deletar Aluno'
                        >
                            <Trash size={20} strokeWidth={2.5}/>
                        </button>
                    </div>}
                </div>
                <div className="perfil-info">
                    <div className="avatar">
                        {getInicial(AlunoInfo.nome)}
                    </div>
                    <h2 className="aluno-nome">{AlunoInfo.nome || 'A carregar...'}</h2>
                    <span className="aluno-turma">Turma - {AlunoInfo.turmaNome || 'Sem Turma'}</span>
                </div>
            </div>

            {/* --- CORPO DA FICHA --- */}
            <div className="perfil-content">
                
                {/* DADOS PESSOAIS (CARD) */}
                <div className="data-card">
                    <h3 className="card-title">Dados Pessoais</h3>
                    <div className="info-list">
                        <div className="info-item">
                            <div className="info-icon"><User size={22} strokeWidth={2.5} /></div>
                            <div className="info-text">
                                <label>Gênero</label>
                                <span>{formatarGenero(AlunoInfo.genero)}</span>
                            </div>
                        </div>
                        <div className="info-item">
                            <div className="info-icon"><Calendar size={22} strokeWidth={2.5} /></div>
                            <div className="info-text">
                                <label>Data de Nascimento</label>
                                <span>{AlunoInfo.dataNascimento}</span>
                            </div>
                        </div>
                    </div>
                </div>

                {/* DESEMPENHO EBD (GRID DE KPIs) */}
                <div className="data-card">
                    <div style={{display:'flex', justifyContent:'space-between', alignItems:'center', flexWrap:'wrap', gap:'8px'}}>
                        <h3 className="card-title">Desempenho na EBD</h3>
                        {/* NOVO: filtro por trimestre — historico.* é um array
                            de 4 posições (1 por trimestre) desde a criação do
                            aluno; antes esses dados só eram exibidos somados. */}
                        <select
                            value={trimestreSelecionado === null ? 'todos' : trimestreSelecionado}
                            onChange={(e) => setTrimestreSelecionado(e.target.value === 'todos' ? null : Number(e.target.value))}
                        >
                            <option value="todos">Ano todo</option>
                            <option value={0}>1º Trimestre</option>
                            <option value={1}>2º Trimestre</option>
                            <option value={2}>3º Trimestre</option>
                            <option value={3}>4º Trimestre</option>
                        </select>
                    </div>
                    <div className="stats-grid">
                        <div className="stat-box">
                            <CheckCircle size={32} className="stat-icon" style={{color: '#10b981'}} strokeWidth={2} />
                            <span className="stat-value">{historico.presencas}</span>
                            <span className="stat-label">Presenças</span>
                        </div>
                        <div className="stat-box">
                            <BookOpen size={32} className="stat-icon" style={{color: '#4c00ff'}} strokeWidth={2} />
                            <span className="stat-value">{historico.revistas}</span>
                            <span className="stat-label">Revistas</span>
                        </div>
                        <div className="stat-box">
                            <Book size={32} className="stat-icon" style={{color: '#f59e0b'}} strokeWidth={2} />
                            <span className="stat-value">{historico.biblias}</span>
                            <span className="stat-label">Bíblias</span>
                        </div>
                        <div className="stat-box">
                            <Award size={32} className="stat-icon" style={{color: '#f43f5e'}} strokeWidth={2} />
                            <span className="stat-value">{historico.pontos}</span>
                            <span className="stat-label">Pontos Acum.</span>
                        </div>
                    </div>
                </div>

            </div>

            {/* Renderiza o formulário de edição caso o botão do lápis seja clicado */}
            {/* {cadastramento && <FormAluno cadastramento={desativarCadastramento} edit={AlunoInfo}/>} */}
        </div>
    );
}